import React, { useState, useEffect ,useContext} from "react";

import { useLocation, useHistory } from "react-router";
import { RBContext } from "../../components/RBContext";
import { IndustryModeEnum, formatPaymentType, paymentTypeEnum } from "../../api/constants";
import { Button, Card, CardContent, createStyles, makeStyles } from "@material-ui/core";
import { AuthService } from "../../api/AuthService";
import { Colors, Font, FontSize, FontWeight, Spacing, UIRelatedConstants } from "../../theme/Theme";
import { CreditCard, AccountBalance, ChevronRight } from "@material-ui/icons";
import { RBAppbar } from "../../components/RBAppbar";
import { PadSetupStatusTypeEnum, stripePadVerificationTypeEnum } from "../../util/Common";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { RBButton } from "../../components/RBButton";
import { getShiftPlacementFeeMessage, hasShiftPlacementFeeInfo } from "../../util/shiftFee";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { renderRBPayText } from "../../components/RBPayWordmark";
import { rbPayrollOwnerService } from "../rbPayrollOwnerSettings/services/rbPayrollOwner.service";
import { isRBPayPaymentMethod } from "../../util/rbPay";
import { RBPayrollStatusBadge } from "../rbPayrollOwnerSettings/components/RBPayrollStatusBadge";
import { RB_PAYROLL_STATUS_COPY } from "../rbPayrollOwnerSettings/constants/rbPayrollOwner.constants";
import { AccountInfoContext } from "../../components/AccountInfoContext";


interface PaymentPageProps {
    account?: any;
    paymentSetup?: any;
    editMode?:any;
    newPharmacy?:any;
}

interface LocationState {
    account?: string;
    editMode?: boolean;
    newPharmacy?: boolean;
  }

export const AddmultiplelocationsPayment: React.FC<PaymentPageProps> = ({
    ...props
  }) => {
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { account, editMode, newPharmacy } = location.state || {};

  const { industryMode, primaryColor, secondaryColor } = useContext(RBContext);
  const [locationsVisible, setLocationsVisible] = useState(false);
  const [locationArr, setLocationArr] = useState<any>([]);
  const [selectedLoc, setSelectedLoc] = useState(null);
  const [newPaymentType, setNewPaymentType] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pharmacyDetails, setPharmacyDetails] = useState<any>([]);
  const [rbPayrollStateByLocation, setRbPayrollStateByLocation] = useState<any>({});
   const [submitErrorMessage, setSubmitErrorMessage] = useState<
      ErrorMessageProps
    >();
  // US 6469: placement-fee note shown by the per-location "View Rates" action.
  const [isRatesAlertShowing, setIsRatesAlertShowing] = useState(false);
  const [ratesMessage, setRatesMessage] = useState("");

  const useStyles = makeStyles(() =>
  createStyles({
    root: {
      textTransform: "none",
      // color: Colors.black,
      "&:hover": {
        color: Colors.themeBlue,
        opacity: 1,
      },
      "&$selected": {
        color: Colors.black,
        fontWeight: "600",
      },
      "&:focus": {
        color: Colors.black,
      },
    },
    selected: {
      //color: Colors.themeBlue,
    },
    indicator: {
      backgroundColor: Colors.black,
    },
    sectionHeader: {
      fontSize: Font.largest, fontWeight:"bold"
      //  backgroundColor: "red",
    },
    Card: {
      // "&:hover": {
      //   backgroundColor: "#E5E5E5",
      // },
    },
    CardContent: {
      paddingTop: 8,
      "&:last-child": {
        paddingBottom: 8,
      },
    },
    button: {
      borderRadius: UIRelatedConstants.ButtonBorderRadius,
      borderWidth: 1,
      backgroundColor: "#FFF",
      "&:hover": {
        backgroundColor: "#CDCDCD",
      },
    },
    // US 6469: full-width "View rates" footer row on the location card.
    ratesFooterRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: Spacing.large,
      minHeight: 48,
      boxSizing: "border-box",
      padding: "16px 28px",
      borderTop: "1.5px solid #E3E3EA",
      backgroundColor: "#FBFBFD",
      cursor: "pointer",
      userSelect: "none",
      "&:hover": {
        backgroundColor: "#F4F4FA",
      },
      "&:active": {
        backgroundColor: "#F1F1F6",
      },
      "&:focus-visible": {
        outline: `2px solid ${primaryColor}`,
        outlineOffset: -2,
      },
    },
    ratesFooterLabel: {
      fontSize: 15,
      fontWeight: 700,
      color: primaryColor,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    // Custom radio button styles
    radioContainer: {
        position: 'relative',
        padding: '10px', // Adjust padding as needed
        cursor: 'pointer',
      },
      radioInput: {
        position: 'absolute',
        opacity: 0,
        cursor: 'pointer',
      },
      radioCheckmark: {
        position: 'absolute',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        width: '20px', // Adjust the size of the tick mark
        height: '20px', // Adjust the size of the tick mark
        border: '2px solid #000', // Set the tick mark color
        borderTop: 'none',
        borderRight: 'none',
        boxSizing: 'border-box',
      },
      radioChecked: {
        backgroundColor: '#000', // Set the tick mark color when checked
      },
  })
  );

  const classes = useStyles();
  
  const { accountInformation, fetchPharmacy } = useContext(AccountInfoContext);

  useEffect(() => {
    (async () => {

      if (!accountInformation) return; //wait for context

      try {
        setLoading(true)
        let accountData = props.account? props.account : account;
        const userData = accountInformation;
        accountData = {
            ...accountData,
            pharmacies: userData.pharmacies
        };

        let pharmaDetails = await fetchPharmacy(accountData.owner.defaultPharmacyId);
        setPharmacyDetails(pharmaDetails)
        setSelectedLoc(pharmaDetails)

        let selectedLocation:any;
        selectedLocation = pharmaDetails;
        const filteredLocations = accountData.pharmacies.filter((location:any) => location.id !== selectedLocation.id);
        const reorderedLocations = [selectedLocation, ...filteredLocations];

        const rbPayrollStateEntries = await Promise.all(
          reorderedLocations.map(async (location: any) => {
            const [setup, options] = await Promise.all([
              rbPayrollOwnerService.getRBPayrollSetup({ account: userData, location }),
              rbPayrollOwnerService.getPaymentOptions({ account: userData, location }),
            ]);

            return [
              String(location?.id || ""),
              {
                setup,
                selected: options.some((option) => option.selected),
              },
            ];
          })
        );
        setRbPayrollStateByLocation(Object.fromEntries(rbPayrollStateEntries));

        reorderedLocations.forEach((value, index) => {
          reorderedLocations[index].checked = false;
          if(reorderedLocations[index] === selectedLocation){
            reorderedLocations[index].checked = true;
          }
        });

        setLocationArr(reorderedLocations)
        if(!editMode)
        {
          setNewPaymentType(true)
        }
    } 
    catch (err) {
      const errorMessage = err.response ? err.response.data.message : err.message;
      setSubmitErrorMessage(errorMessage);
    } finally {
      setLoading(false);
    }
      
    })();

  }, [accountInformation]);

  useEffect(() => {
    (async () => {
      if(props?.account?.newPharmacy  === true || newPharmacy === true)
      {

        let accountData = props.account? props.account : account;
        setSelectedLoc(accountData.pharmacies[accountData.pharmacies.length-1])
        const selectedLocation = accountData.pharmacies[accountData.pharmacies.length-1];
        const filteredLocations = accountData.pharmacies.filter((location:any) => location !== selectedLocation);
        const reorderedLocations = [selectedLocation, ...filteredLocations];

        const rbPayrollStateEntries = await Promise.all(
          reorderedLocations.map(async (location: any) => {
            const [setup, options] = await Promise.all([
              rbPayrollOwnerService.getRBPayrollSetup({ account: accountData, location }),
              rbPayrollOwnerService.getPaymentOptions({ account: accountData, location }),
            ]);

            return [
              String(location?.id || ""),
              {
                setup,
                selected: options.some((option) => option.selected),
              },
            ];
          })
        );
        setRbPayrollStateByLocation(Object.fromEntries(rbPayrollStateEntries));

        reorderedLocations.forEach((value, index) => {
          reorderedLocations[index].checked = false;
          if(reorderedLocations[index] === selectedLocation){
            reorderedLocations[index].checked = true;
          }
        });

        setNewPaymentType(true)
        setLocationArr(reorderedLocations)
      }
    })();

  }, [props?.account?.newPharmacy || newPharmacy])




  const handleRadioButtonChange = (index:number) => {
    setSelectedLoc(locationArr[index]);
  }
  // US 6469: show the shift placement-fee note for a single location. This is the
  // same pop-up that used to be shown when opening Create Shift; it now lives on
  // Payment Settings, one per location. The row's own location object is passed
  // in (never the selected-location state) so Location A can never render
  // Location B's rates. "Ok" just closes the dialog, leaving the user on the
  // Payment Settings home page.
  const showShiftRates = (location: any) => {
    setRatesMessage(getShiftPlacementFeeMessage(location));
    setIsRatesAlertShowing(true);
  };

  const choosePaymentOption = (type:any, locationOverride?: any) =>{
    const resolvedLocation = locationOverride || selectedLoc;
    let editMode = type == 'add' ? false : true;
    history.push('/paymentOption',{
        editMode: editMode,
        selectedLoc: resolvedLocation
      });
  }

  const renderLocations = () =>{
    return(
      <div style={{ flex: 1 }}>
              {locationArr.map((location:any, index:number) => {
                let defaultPayment = null;
                const rbPayrollState = rbPayrollStateByLocation[String(location?.id || "")];
                const rbPayrollSetup = rbPayrollState?.setup;
                // Show RB Pay only when it is the location's CURRENT method:
                // paymentType "rb_pay" (active), or a pending setup with no other
                // method chosen yet (paymentType empty + status off NOT_STARTED).
                // Switching to CC/PAD/Invoice sets paymentType to that method, so RB
                // Pay stops showing even though the approved RB Pay profile persists
                // in the backend. (This also keeps an abandoned-before-save setup on
                // "Add", since that leaves status NOT_STARTED and paymentType empty.)
                const locationPaymentType = location?.paymentType;
                const shouldRenderRBPayroll = Boolean(
                  isRBPayPaymentMethod(locationPaymentType) ||
                    (!locationPaymentType &&
                      rbPayrollSetup?.approval?.status &&
                      rbPayrollSetup.approval.status !== "NOT_STARTED")
                );
                if (location.paymentType && location.paymentType === paymentTypeEnum.creditCard) {
                  if (location.creditCards && location.creditCards.length > 0) {
                    defaultPayment = location.creditCards.find((x:any) => x.category == 'shift');
                  }
                }
                else if (location.paymentType && location.paymentType === paymentTypeEnum.pad) {
                  if (location.bankAccounts && location.bankAccounts.length > 0) {
                    defaultPayment = location.bankAccounts.find((x:any) => x.isDefault);
                  }
                }
                else if (location.paymentType && location.paymentType === paymentTypeEnum.invoice) {
                  defaultPayment = formatPaymentType(paymentTypeEnum.invoice)
                } else {

                }

                if (shouldRenderRBPayroll) {
                  defaultPayment = rbPayrollSetup || { approval: { status: "NOT_STARTED" } };
                }

                const rbPayrollCopy = shouldRenderRBPayroll
                  ? RB_PAYROLL_STATUS_COPY[
                      (rbPayrollSetup?.approval?.status || "NOT_STARTED") as keyof typeof RB_PAYROLL_STATUS_COPY
                    ]
                  : null;
                return (
                    
                <div
                style={{
                  width: "100%",
                  paddingLeft: Spacing.large,
                  paddingRight: Spacing.large,
                  paddingBottom: Spacing.medium,
                  paddingTop: Spacing.large
                }}
                onClick={() => handleRadioButtonChange(index)}
              >
                <Card
                  variant="outlined"
                  className={classes.Card}
                  style={{
                    borderRadius: UIRelatedConstants.CardBorderRadius,
                    borderWidth: 3,
                    borderColor: primaryColor,
                    // Required so the footer row's fill clips to the card radius.
                    overflow: "hidden",
                  }}
                >
                     <CardContent className={classes.CardContent}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            paddingTop: 10,
                            justifyContent: "space-between",
                            minHeight: 45,
                        }}
                    >
                        <div style={{ justifyContent: "center" }}>
                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                {locationArr.length > 1 &&
                                     <label>
                                        <input
                                        type="radio"
                                        id={`paymentOptionId-${index}`}
                                        name="paymentOption"
                                        value={index}
                                        checked={selectedLoc === locationArr[index]}
                                        required
                                        onChange={() => handleRadioButtonChange(index)}
                                        className={classes.radioInput}
                                        style={{ display: 'none' }}
                                    />
                                     <div style={{color:secondaryColor,fontSize:18, fontWeight:"bold"}}>
                                        {selectedLoc === locationArr[index] ? '✓' : ''}
                                    </div>
                                    </label>}

                                <label htmlFor={`paymentOptionId-${index}`} style={{ marginLeft: 8, fontWeight: 'bold', fontSize: 16, paddingLeft: locationArr.length > 1 ? 0 : Spacing.medium }}>
                                    {location.name}
                                </label>
                            </div>
                        </div>

                        <div
                            style={{ alignItems: "flex-end" }}

                        >
                            <div>
                                {defaultPayment == null ?
                                    <Button
                                        className={classes.button}
                                        disabled={selectedLoc !== locationArr[index]}
                                        variant="outlined"
                                        style={{
                                            borderColor: secondaryColor,
                                            color: Colors.white,
                                            textTransform: "none",
                                            background: secondaryColor
                                        }}
                                        onClick={() => choosePaymentOption('add', locationArr[index])}
                                    >
                                        {"Add"}
                                    </Button> :
                                    <div style={{ display: "flex", gap: "8px" }}> 
                                     <Button
                                        className={classes.button}
                                        disabled={selectedLoc !== locationArr[index]}
                                        variant="outlined"
                                        style={{
                                            borderColor: primaryColor,
                                            color: Colors.white,
                                            textTransform: "none",
                                            background: primaryColor
                                        }}
                                        onClick={() => {
                                          if (shouldRenderRBPayroll) {
                                            history.push('/viewPaymentMethods', {
                                              selectedLoc: locationArr[index]
                                            });
                                            return;
                                          }

                                          history.push('/viewPaymentMethods', {
                                            selectedLoc: locationArr[index]
                                          });
                                        }}
                                    >
                                        {"View"}
                                    </Button>
                                    <Button
                                        className={classes.button}
                                        disabled={selectedLoc !== locationArr[index]}
                                        variant="outlined"
                                        style={{
                                            borderColor: secondaryColor,
                                            color: Colors.white,
                                            textTransform: "none",
                                            background: secondaryColor
                                        }}
                                        onClick={() => {
                                          if (shouldRenderRBPayroll) {
                                            choosePaymentOption('edit', locationArr[index])
                                            return;
                                          }

                                          choosePaymentOption('edit', locationArr[index])
                                        }}
                                    >
                                        {"Edit"}
                                    </Button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                     
                    {defaultPayment &&
                    <div style={{ marginLeft: 50, marginTop: 12, marginBottom: 15 }}>
                      {shouldRenderRBPayroll && rbPayrollSetup && (
                        <>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: Spacing.small, marginBottom: 8, flexWrap: 'wrap' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4 }}>
                              <AccountBalance />
                              <div style={{ flex: 1, fontWeight: 'bold', paddingLeft: 12 }}>
                                  {renderRBPayText("RB Pay")}
                              </div>
                            </div>
                            <RBPayrollStatusBadge status={rbPayrollSetup.approval?.status} />
                          </div>

                          <div style={{ paddingLeft: 34, color: Colors.darkGrey }}>
                            {rbPayrollSetup.approval?.rejectionReason || rbPayrollCopy?.description}
                          </div>
                        </>
                      )}
                      {locationArr[index].paymentType === paymentTypeEnum.pad &&
                        !shouldRenderRBPayroll &&
                        <>
                          <div style={{ display: 'flex',flexDirection: 'row', alignItems: 'center',marginBottom:4 }}>
                            <AccountBalance />
                            <div style={{ flex: 1, fontWeight: 'bold' , paddingLeft: 12}}>
                              {formatPaymentType(paymentTypeEnum.pad)}
                            </div>
                          </div>

                          <div style={{ paddingLeft: 34 }}>
                            Bank: {defaultPayment.bankName}
                          </div>
                          <div style={{ marginTop: 4, paddingLeft: 34 }}>
                            Acc No: XXXX XXXX {defaultPayment.accountNumberLastFour}
                          </div>
                        </>}
                     {(locationArr[index].paymentType === paymentTypeEnum.creditCard) &&
                        !shouldRenderRBPayroll &&
                        <>
                           <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4 }}>
                            <CreditCard />
                            <div style={{ flex: 1, fontWeight: 'bold', paddingLeft: 10 }}>
                              {formatPaymentType(paymentTypeEnum.creditCard)}
                            </div>
                          </div>

                          <div style={{  paddingLeft: 34, }}>
                            {defaultPayment.type} ending with {defaultPayment.lastFourDigits}
                          </div>
                          <div style={{ marginTop: 4, paddingLeft: 34 }}>
                            Expires: {defaultPayment.expiryMonth}/{defaultPayment.expiryYear}
                          </div>
                        </>
                      }
                      {locationArr[index].paymentType === paymentTypeEnum.invoice &&
                        !shouldRenderRBPayroll &&
                        <>
                          <div style={{ display: 'flex',flexDirection: 'row', alignItems: 'center',marginBottom:4 }}>
                          <AccountBalance />
                            <div style={{ flex: 1,  fontWeight: 'bold', paddingLeft: 12, }}>
                            {formatPaymentType(paymentTypeEnum.invoice)}
                            </div>
                          </div>
                        </>
                      }

                    </div>}


                  {locationArr[index]?.bankAccounts?.length > 0 && 
                    locationArr[index]?.bankAccounts?.[0]?.verificationType === stripePadVerificationTypeEnum.MicroDeposits && 
                    locationArr[index]?.bankAccounts?.[0]?.setupStatus === PadSetupStatusTypeEnum.InProgress &&
                     <div style={{ flexDirection: 'row', alignItems: 'center',marginBottom:8 }}>
                       <div style={{ flex: 1,  fontWeight: 'bold', paddingLeft: 12, color:'red'  }}>
                        * Your Pre-Authorized Debit (PAD) verification is in progress. Micro-deposit verification can take 1–2 business days to complete. Please check your bank account for deposit amounts and verify them to complete the setup.
                       </div>
                    </div>}
                    </CardContent>

                  {/* US 6469: per-location "View rates" — opens the placement-fee note
                      that used to be shown when opening Create Shift. Full-width row so
                      it reads as navigation rather than competing with View/Edit. Only
                      rendered inside Payment Settings, not in the set-up flow. */}
                  {props.paymentSetup && hasShiftPlacementFeeInfo(location) &&
                    <div
                      className={classes.ratesFooterRow}
                      role="button"
                      tabIndex={0}
                      aria-label={`View rates for ${location.name}`}
                      onClick={(event) => {
                        // Keep the card's selection (used by Add/View/Edit) untouched.
                        event.stopPropagation();
                        showShiftRates(location);
                      }}
                      onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault();
                          event.stopPropagation();
                          showShiftRates(location);
                        }
                      }}
                    >
                      <div className={classes.ratesFooterLabel}>View rates</div>
                      <ChevronRight style={{ color: primaryColor, fontSize: 22, flexShrink: 0 }} />
                    </div>}

                  </Card>
                  </div>
                )
              })}
            </div>
    )
  }
  const renderContent = () => {
    const { account } = props;
    return (
      <>
      {loading ? (
          <LoadingIndicator />
        ) :
      (!props.paymentSetup ? 
        <div>
        <div style={{ padding: 16 }}>
          <div
            style={{ flex: 1, flexDirection: 'row', alignContent: 'center' }}
          >

            {renderLocations()}
          </div>
        </div>
      </div>
      :
      <div>
        {renderLocations()}
      </div>

      )}
      </>
    );
    
  }

  
  return (
    <>
       <RBAlert
              show={isRatesAlertShowing}
              alertTitle={"Note"}
              alertMessage={ratesMessage}
              buttons={[
                <RBButton
                  key={"confirm"}
                  onClick={() => setIsRatesAlertShowing(false)}
                  buttonBackgroundColor={primaryColor}
                  color="primary"
                  text="Ok"
                />,
              ]}
            />
      <RBErrorAlert
              show={submitErrorMessage ? true : false}
              errorMessage={JSON.stringify(submitErrorMessage, null, 2)}
              onClose={() => {
                setSubmitErrorMessage(undefined);
              }}
            />

      <div style={{ flex: 1 }}>
          {!props.paymentSetup ?

              <div>
                   <RBAppbar
                    deeperLevel={true}
                    barName={"Choose Location to Set-up Payment"}
                  />
                  {renderContent()}
              </div>
              :
              renderContent()

          }
      </div>
      </>
  );
}
